/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Currency used for entry fees and prize pools
 * @export
 */
export const TournamentCurrency = {
    USD: 'USD',
    FUEL: 'FUEL'
} as const;
export type TournamentCurrency = typeof TournamentCurrency[keyof typeof TournamentCurrency];


export function instanceOfTournamentCurrency(value: any): boolean {
    for (const key in TournamentCurrency) {
        if (Object.prototype.hasOwnProperty.call(TournamentCurrency, key)) {
            if (TournamentCurrency[key as keyof typeof TournamentCurrency] === value) {
                return true;
            }
        }
    }
    return false;
}

export function TournamentCurrencyFromJSON(json: any): TournamentCurrency {
    return TournamentCurrencyFromJSONTyped(json, false);
}

export function TournamentCurrencyFromJSONTyped(json: any, ignoreDiscriminator: boolean): TournamentCurrency {
    return json as TournamentCurrency;
}

export function TournamentCurrencyToJSON(value?: TournamentCurrency | null): any {
    return value as any;
}

export function TournamentCurrencyToJSONTyped(value: any, ignoreDiscriminator: boolean): TournamentCurrency {
    return value as TournamentCurrency;
}

